import repository from './repsitory'

const resource = '/person'

export default {
    get () {
        return repository.get(`${resource}`)
    },
    getById (id) {
        return repository.get(`${resource}/${id}`)
    },
    addPerson (data) {
        return repository.post(`${resource}`, data)
    },
    updatePerson (data, id) {
        return repository.put(`${resource}/${id}`, data)
    },
    getByCourierGroup (courierGroupId) {
        return repository.get(`${resource}/courierGroup/${courierGroupId}`)
    },
    getRoutersWithOutGroup () {
        return repository.get(`${resource}/routers/withOutGroup`)
    },
}
